"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calendarViewUnits = exports.calendarViewHierarchy = exports.calendarViews = exports.directions = void 0;
var views = {
  MONTH: 'month',
  YEAR: 'year',
  DECADE: 'decade',
  CENTURY: 'century'
};
exports.directions = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  UP: 'UP',
  DOWN: 'DOWN'
};
exports.calendarViews = views;
exports.calendarViewHierarchy = {
  month: 'year',
  year: 'decade',
  decade: 'century'
};
exports.calendarViewUnits = {
  month: 'day',
  year: 'month',
  decade: 'year',
  century: 'decade'
};
exports.default = {
  directions: exports.directions,
  calendarViews: exports.calendarViews,
  calendarViewHierarchy: exports.calendarViewHierarchy,
  calendarViewUnits: exports.calendarViewUnits
};